const ACTIONABLE_APPOINTMENT_STATUSES = new Set(['created', 'scheduled', 'waiting']);

export const APPOINTMENT_JOIN_START_MINUTES = 15;
export const APPOINTMENT_JOIN_END_MINUTES = 10;

export const isActionableAppointmentStatus = (status) => {
  return ACTIONABLE_APPOINTMENT_STATUSES.has(String(status || '').toLowerCase());
};

export const minutesUntilAppointment = (appointmentDate) => {
  const date = appointmentDate instanceof Date ? appointmentDate : new Date(appointmentDate);
  if (Number.isNaN(date.getTime())) return Infinity;

  return Math.floor((date.getTime() - Date.now()) / (1000 * 60));
};

export const getAppointmentActionState = (appointment) => {
  if (!appointment?.date_appt || !isActionableAppointmentStatus(appointment.status)) {
    return { isActionable: false, isJoinable: false, isCancellable: false, isMissed: false };
  }

  const minutesUntilAppt = minutesUntilAppointment(appointment.date_appt);
  const isJoinable = minutesUntilAppt <= APPOINTMENT_JOIN_START_MINUTES && minutesUntilAppt >= -APPOINTMENT_JOIN_END_MINUTES;
  const isCancellable = minutesUntilAppt > APPOINTMENT_JOIN_START_MINUTES;
  const isMissed = minutesUntilAppt < -APPOINTMENT_JOIN_END_MINUTES;

  return {
    isActionable: true,
    isJoinable,
    isCancellable,
    isMissed,
    minutesUntilAppt,
  };
};

export const isUpcomingAppointment = (appointment) => {
  const actionState = getAppointmentActionState(appointment);
  return actionState.isActionable && !actionState.isMissed;
};

// The server's refund message when a paid appointment was cancelled but the
// refund did not go through; null otherwise. Shown verbatim to the patient.
export const refundFailureMessage = (result) => {
  if (!result || result.refund_processed !== false) return null;
  const msg = String(result.refund_error || '').trim();
  return msg || null;
};
